import React from "react";
import DOMPurify from 'dompurify';

const WebContentResponseForms = ({props}) => {
return (
    <div
        dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
                props.webContentResponse,
                {USE_PROFILES: {html: true}}
            ),
        }}
    ></div>
    );
};

export default WebContentResponseForms;